<template>
  <div class="cabinet-content-container">
    <div class="content">
      <div class="cabinet-header">
        <h4> Available Cabinets </h4>
        <DxButton text="New Cabinet"
                  icon="add"
                  type="default"
                  :width="150"
                  :height="40"
                  @click="cabinetsPageStore.setOpenNewCabinetPopup(true)"
        />
      </div>
      <CabinetsGrid/>
       <NewCabinetPopup v-model:visible="openNewCabinetPopup" @close-popup="cabinetsPageStore.setOpenNewCabinetPopup(false)"/>
    </div>
  </div>
</template>

<script setup>
  import CabinetsGrid from "@/components/cabinets-page/CabinetsGrid.vue";
  import NewCabinetPopup from "@/components/cabinets-page/NewCabinetPopup.vue";
  import { DxButton } from "devextreme-vue";
  import { storeToRefs } from 'pinia';
  import { useCabinetsPageStore } from "@/stores/cabinetsPageStore.js";

  const cabinetsPageStore = useCabinetsPageStore()
  const { openNewCabinetPopup } = storeToRefs(cabinetsPageStore)

  cabinetsPageStore.getCabinetList()
</script>

<style scoped lang="scss">
  .cabinet-content-container {
    display: flex;
    justify-content: center;
    padding: 1.25rem;
    background-color: $white-normal;

    .content {
      display: flex;
      flex-direction: column;
      max-width: 65rem;

      .cabinet-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
</style>
